import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7081/RpData";
	}
	addressSuggestion(e, t, r) {
		let i = this.baseUrl + "/AddressSuggestion";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
		if (i += "query=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		i += "state=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processAddressSuggestion(e)));
	}
	processAddressSuggestion(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 500 ? b("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : b("An unexpected server error occurred.", e.status, e.data, t);
	}
	generateEventSubscriptions(e) {
		let t = this.baseUrl + "/GenerateEventSubscriptions", r = {
			method: "POST",
			url: t,
			headers: {},
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGenerateEventSubscriptions(e)));
	}
	processGenerateEventSubscriptions(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 500 ? b("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : b("An unexpected server error occurred.", e.status, e.data, t);
	}
	getComparableProperties(e, t, r, i, a, o, s, c, l, u) {
		let d = this.baseUrl + "/GetComparableProperties";
		if (d += "?", e == null) throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
		if (d += "page=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
		if (d += "pageSize=" + encodeURIComponent(f(t)) + "&", r === null) throw new globalThis.Error("The parameter 'propertyId' cannot be null.");
		if (r !== void 0 && (d += "propertyId=" + encodeURIComponent(f(r)) + "&"), i === null) throw new globalThis.Error("The parameter 'radius' cannot be null.");
		if (i !== void 0 && (d += "radius=" + encodeURIComponent(f(i)) + "&"), a === null) throw new globalThis.Error("The parameter 'minBedrooms' cannot be null.");
		if (a !== void 0 && (d += "minBedrooms=" + encodeURIComponent(f(a)) + "&"), o === null) throw new globalThis.Error("The parameter 'maxBedrooms' cannot be null.");
		if (o !== void 0 && (d += "maxBedrooms=" + encodeURIComponent(f(o)) + "&"), s === null) throw new globalThis.Error("The parameter 'propertyType' cannot be null.");
		if (s !== void 0 && (d += "propertyType=" + encodeURIComponent(f(s)) + "&"), c === null) throw new globalThis.Error("The parameter 'latitude' cannot be null.");
		if (c !== void 0 && (d += "latitude=" + encodeURIComponent(f(c)) + "&"), l === null) throw new globalThis.Error("The parameter 'longitude' cannot be null.");
		l !== void 0 && (d += "longitude=" + encodeURIComponent(f(l)) + "&"), d = d.replace(/[?&]$/, "");
		let p = {
			method: "GET",
			url: d,
			headers: { Accept: "application/json" },
			signal: u
		};
		return this.transformOptions(p).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(d, e, (e) => this.processGetComparableProperties(e)));
	}
	processGetComparableProperties(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? b("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : b("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPropertySummary(e, t, r) {
		let i = this.baseUrl + "/GetPropertySummary";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'address' must be defined and cannot be null.");
		if (i += "address=" + encodeURIComponent(f(e)) + "&", t === null) throw new globalThis.Error("The parameter 'propertyId' cannot be null.");
		t !== void 0 && (i += "propertyId=" + encodeURIComponent(f(t)) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetPropertySummary(e)));
	}
	processGetPropertySummary(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? b("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : b("An unexpected server error occurred.", e.status, e.data, t);
	}
	getRpDataAuthorizationUrl(e, t) {
		let r = this.baseUrl + "/GetRpDataAuthorizationUrl";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'returnPage' must be defined and cannot be null.");
		r += "returnPage=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetRpDataAuthorizationUrl(e)));
	}
	processGetRpDataAuthorizationUrl(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? b("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : b("An unexpected server error occurred.", e.status, e.data, t);
	}
	getTitleReference(e) {
		let t = this.baseUrl + "/GetTitleReference", r = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetTitleReference(e)));
	}
	processGetTitleReference(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 500 ? b("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : b("An unexpected server error occurred.", e.status, e.data, t);
	}
	getVendorDetails(e, t) {
		let r = this.baseUrl + "/GetVendorDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'propertyId' must be defined and cannot be null.");
		r += "propertyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: {},
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetVendorDetails(e)));
	}
	processGetVendorDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : b("An unexpected server error occurred.", e.status, e.data, t);
	}
	planSuggestion(e, t, r) {
		let i = this.baseUrl + "/PlanSuggestion";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
		if (i += "query=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		i += "state=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processPlanSuggestion(e)));
	}
	processPlanSuggestion(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 500 ? b("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : b("An unexpected server error occurred.", e.status, e.data, t);
	}
	storeAccessCode(e, t) {
		let r = this.baseUrl + "/StoreAccessCode", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStoreAccessCode(e)));
	}
	processStoreAccessCode(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? b("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : b("An unexpected server error occurred.", e.status, e.data, t);
	}
	suburbSuggestion(e, t, r) {
		let i = this.baseUrl + "/SuburbSuggestion";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
		if (i += "query=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		i += "state=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processSuburbSuggestion(e)));
	}
	processSuburbSuggestion(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 500 ? b("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : b("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.SquareMetres = "SquareMetres", e.Hectares = "Hectares", e.Acres = "Acres", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.BuiltOn = "BuiltOn", e.VacantLand = "VacantLand", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Lifestyle = "Lifestyle", e.MixedFarming = "MixedFarming", e.Farmlet = "Farmlet", e.Livestock = "Livestock", e.Other = "Other", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), y = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isRpDataApiException = !0;
	static isRpDataApiException(e) {
		return e.isRpDataApiException === !0;
	}
};
function b(e, t, n, r, i) {
	throw i ?? new y(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var x = "rpdata";
function S(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var C = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), S(r);
}, w = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[x] || `${e}/${x}`;
}, T = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = w(i), u = c, d = C(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = C(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, E = a({}), D = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = T(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(E.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, O = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(E), c;
	i[0] !== e || i[1] !== t ? (c = [
		"addressSuggestion",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.addressSuggestion(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, k = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"addressSuggestion",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, A = (e, t, n, i, a, s, c, l, d, f) => {
	let p = r(29), m = f === void 0 || f, h = o(E), g;
	p[0] !== l || p[1] !== d || p[2] !== s || p[3] !== a || p[4] !== e || p[5] !== t || p[6] !== n || p[7] !== c || p[8] !== i ? (g = [
		"getComparableProperties",
		e,
		t,
		n,
		i,
		a,
		s,
		c,
		l,
		d
	], p[0] = l, p[1] = d, p[2] = s, p[3] = a, p[4] = e, p[5] = t, p[6] = n, p[7] = c, p[8] = i, p[9] = g) : g = p[9];
	let _ = g, v;
	p[10] !== h || p[11] !== l || p[12] !== d || p[13] !== s || p[14] !== a || p[15] !== e || p[16] !== t || p[17] !== n || p[18] !== c || p[19] !== i ? (v = (r) => {
		let { signal: o } = r;
		return h.getComparableProperties(e, t, n, i, a, s, c, l, d, o);
	}, p[10] = h, p[11] = l, p[12] = d, p[13] = s, p[14] = a, p[15] = e, p[16] = t, p[17] = n, p[18] = c, p[19] = i, p[20] = v) : v = p[20];
	let y = m && !!h, b;
	p[21] !== _ || p[22] !== v || p[23] !== y ? (b = {
		queryKey: _,
		queryFn: v,
		enabled: y
	}, p[21] = _, p[22] = v, p[23] = y, p[24] = b) : b = p[24];
	let { data: x, isPending: S, isError: C } = u(b), w;
	return p[25] !== x || p[26] !== C || p[27] !== S ? (w = {
		data: x,
		isPending: S,
		isError: C
	}, p[25] = x, p[26] = C, p[27] = S, p[28] = w) : w = p[28], w;
}, j = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o, s, c, l) => {
		await t.invalidateQueries({ queryKey: [
			"getComparableProperties",
			e,
			n,
			r,
			i,
			a,
			o,
			s,
			c,
			l
		] });
	}, e[0] = t, e[1] = n), n;
}, M = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(E), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getPropertySummary",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getPropertySummary(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, N = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getPropertySummary",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, P = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(E), s;
	n[0] === e ? s = n[1] : (s = ["getRpDataAuthorizationUrl", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getRpDataAuthorizationUrl(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, F = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getRpDataAuthorizationUrl", e] });
	}, e[0] = t, e[1] = n), n;
}, I = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(E), s;
	t[0] === a ? s = t[1] : (s = async () => a.getTitleReference(), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getTitleReference: u,
		getTitleReferencePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, L = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(E), s;
	n[0] === e ? s = n[1] : (s = ["getVendorDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getVendorDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, R = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getVendorDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, z = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(E), c;
	i[0] !== e || i[1] !== t ? (c = [
		"planSuggestion",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.planSuggestion(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, B = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"planSuggestion",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, V = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(E), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.storeAccessCode(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		storeAccessCode: u,
		storeAccessCodePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, H = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(E), c;
	i[0] !== e || i[1] !== t ? (c = [
		"suburbSuggestion",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.suburbSuggestion(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, U = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"suburbSuggestion",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
};
//#endregion
export { m as LandAreaDetailsTotalLandAreaType, h as PropertyDetailsBuiltOnOrVacantLandType, g as PropertyDetailsRuralType, _ as PropertySuggestionItemState, E as RpDataApiContext, y as RpDataApiException, D as RpDataApiProvider, p as RpDataClient, x as RpDataRoute, v as SuburbSuggestionItemState, O as useAddressSuggestion, A as useGetComparableProperties, M as useGetPropertySummary, P as useGetRpDataAuthorizationUrl, I as useGetTitleReference, L as useGetVendorDetails, k as useInvalidateUseAddressSuggestion, j as useInvalidateUseGetComparableProperties, N as useInvalidateUseGetPropertySummary, F as useInvalidateUseGetRpDataAuthorizationUrl, R as useInvalidateUseGetVendorDetails, B as useInvalidateUsePlanSuggestion, U as useInvalidateUseSuburbSuggestion, z as usePlanSuggestion, T as useRpDataClientContext, V as useStoreAccessCode, H as useSuburbSuggestion };
